var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Link",style:({
    '--link-color': ("var(--primary-" + _vm.theme + ")"),
    '--link-hover-color': ("var(--primary-" + _vm.theme + "_10)")
  })},_vm._l((_vm.content),function(link){return _c('div',{key:link.url,staticClass:"Link__container"},[_c('a',{staticClass:"Link__url",attrs:{"href":link.url,"target":"_blank"}},[_vm._v(_vm._s(link.label || _vm.$t('general.cta.discover')))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }